import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const isLessThanADayLeft = (date: Dayjs) => {
	return dayjs(date).diff(dayjs(), 'hour') < 24;
};

const getTimeDifferenceFromNow = (date: Dayjs) => {
	const difference = dayjs(date).diff(dayjs());
	return Math.max(difference, 0);
};

export const checkIsQuestFinished = (date: Dayjs) => {
	return dayjs(date).isBefore(dayjs());
};

export const checkIsQuestStarted = (date: Dayjs) => {
	return !dayjs().isBefore(dayjs(date)) || dayjs().isSame(dayjs(date));
};

const formatDate = (date: Dayjs) => {
	return dayjs(date).format('DD.MM');
};

export const formatTime = (date: Dayjs, t: any) => {
	const diffMilliseconds = getTimeDifferenceFromNow(date);
	const diffDuration = dayjs.duration(diffMilliseconds);

	const hours = diffDuration.hours().toString().padStart(2, '0');
	const minutes = diffDuration.minutes().toString().padStart(2, '0');
	const seconds = diffDuration.seconds().toString().padStart(2, '0');

	return `${hours}${t('hours.short')}: ${minutes}${t('minutes.short')}: ${seconds}${t('seconds.short')}`;
};

export type SeparatedDate = {
	days: number;
	hours: string;
	minutes: string;
	seconds: string;
};

export const formatTimeFromSeconds = (seconds: number, t: any) => {
	const duration = dayjs.duration(seconds * 1000);

	const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
	const minutes = duration.minutes().toString().padStart(2, '0');
	const secondsPart = duration.seconds().toString().padStart(2, '0');

	return `${hours}${t('hours.short')}: ${minutes}${t('minutes.short')}: ${secondsPart}${t('seconds.short')}`;
};

export const formatSeparatedTimeFromSeconds = (seconds: number): SeparatedDate => {
	const duration = dayjs.duration(seconds * 1000);

	const days = Math.floor(duration.asDays()).toString().padStart(2, '0');
	const hours = Math.floor(duration.asHours() % 24)
		.toString()
		.padStart(2, '0');
	const minutes = duration.minutes().toString().padStart(2, '0');
	const secondsPart = duration.seconds().toString().padStart(2, '0');

	return { days: +days, hours, minutes, seconds: secondsPart };
};

export const getQuestDate = (startDate: string, endDate: string, t: any) => {
	const start = dayjs(startDate);
	const end = dayjs(endDate);
	const showTime = isLessThanADayLeft(end);
	const isFinished = checkIsQuestFinished(end);

	if (showTime && !isFinished) {
		return {
			isTime: showTime,
			dateText: formatTime(end, t)
		};
	}

	return {
		isTime: showTime && !isFinished,
		dateText: formatDate(start) + '-' + formatDate(end)
	};
};

export const getStartEndDate = (startDate: string, endDate: string) => {
	const start = dayjs(startDate);
	const end = dayjs(endDate);
	const showTime = isLessThanADayLeft(end);
	const isFinished = checkIsQuestFinished(end);

	return {
		isTime: showTime && !isFinished,
		dateText: formatDate(start) + '-' + formatDate(end)
	};
};
